import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';

export const fetchBusinessProfile = async (query) => {
  const { data } = await apiClient.get(`/business-profiles/${query.queryKey[1].profile_id}`);
  return data;
};

export const useGetBusinessProfileHandler = (shopId, profile_id) => {
  const dispatch = useDispatch();
  const [businessProfile, setBusinessProfile] = useState({});

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['business-profile', { shopId, profile_id }],
    queryFn: fetchBusinessProfile,
    enabled: !!profile_id,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData && shopId) {
      setBusinessProfile((prev) => ({
        ...prev,
        [shopId]: fetchedData,
      }));
    }
  }, [fetchedData, shopId]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return { businessProfile };
};
